import { all } from "redux-saga/effects";
import abdmWatcher from "./abdm/saga";
import appWatcher from "./app/saga";
import authWatcher from "./authentication/saga";
import documentsWatcher from "./documents/saga";
import downloadsWatcher from "./downloads/saga";
import fitnessWatcher from "./fitness/saga";
import intentsWatcher from "./intent/saga";
import mockWatcher from "./mock/saga";
import notificationsWatcher from "./notifications/saga";
import patientsWatcher from "./patients/saga";
import queryWatcher from "./query/saga";
import statusWatcher from "./status/saga";

export default function* rootSaga() {
  yield all([
    abdmWatcher(),
    appWatcher(),
    authWatcher(),
    documentsWatcher(),
    downloadsWatcher(),
    fitnessWatcher(),
    intentsWatcher(),
    mockWatcher(),
    notificationsWatcher(),
    patientsWatcher(),
    queryWatcher(),
    statusWatcher()
  ]);
}
